import React, { useState, useEffect } from "react";
import styles from "../../styles/components/frameworkPdfComponent.module.scss";
import Icons from "../../public/assets/svg/index";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import _get from "lodash/get";
import { useMediaQuery } from "react-responsive";
import endpoints from "../../utility/endpoints";
import AreyousureModal from "../../pages/successModal";
import endPoints from "../../utility/endpoints";
import axios from "axios";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function index(props) {
  //console.log("props framewrokcomponent-----", props);
  const [transformedDocuments, setTransformedDocuments] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [areYouSure, setAreYouSure] = useState(false);

  //console.log(props, "frameworkprops");

  let pdfObj = {};
  for (let i in props.docsData) {
    pdfObj[i] = `${endpoints.fetchBlobUrl}/${props.docsData[i].docUrl}`;
  }
  //console.log(pdfObj, "pdfobj");

  const [automationCheckedState, setAutomationCheckedState] = React.useState(
    {}
  );
  const [pdfLink, setPdfLink] = React.useState(pdfObj);

  const selectDocumentsHandler = (event, index) => {
    const isChecked = event.target.checked;
    //console.log(transformedDocuments, "transformedDocs");
    const newTransformedDocuments = [...transformedDocuments];

    if (isChecked) {
      newTransformedDocuments[index].isSelected = true;
    } else {
      newTransformedDocuments[index].isSelected = false;
    }

    if (checkIfAnyDocumentSelected(newTransformedDocuments)) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }

    setTransformedDocuments(newTransformedDocuments);
  };

  const selectAllDocuments = (e) => {
    const newTransformedDocuments = [...transformedDocuments];
    if (e.target.checked) {
      for (let i in newTransformedDocuments) {
        newTransformedDocuments[i].isSelected = true;
      }
    } else {
      for (let i in newTransformedDocuments) {
        newTransformedDocuments[i].isSelected = false;
      }
    }

    if (checkIfAnyDocumentSelected(newTransformedDocuments)) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }

    setTransformedDocuments(newTransformedDocuments);
  };

  const checkIfAnyDocumentSelected = (documents) => {
    return documents.some((document) => document.isSelected === true);
  };

  const downloadSelectedDocuments = () => {
    if (!checkIfAnyDocumentSelected(transformedDocuments)) {
      return;
    }

    const selectedDocuments = transformedDocuments.filter(
      (document) => document.isSelected === true
    );

    //console.log("Selected Documents", selectedDocuments);

    if (selectedDocuments.length === 1) {
      window.open(`${endpoints.fetchBlobUrl}/FrameworkDocuments/${selectedDocuments[0].docUrl}`);
    } else {
      downloadZipForDocuments(selectedDocuments);
    }
  };

  const downloadAllDocuments = () => {
    //  console.log("docsdata", props.docsData);
    downloadZipForDocuments(props.docsData);
  };

  const downloadZipForDocuments = (documents) => {
    props.setLoader(true);
    const zip = new JSZip();
    const zipFolderName = "Documents.zip";
    let count = 0;

    documents.forEach((document) => {
      const fileName = document.docName;
      const filePath = `${endpoints.fetchBlobUrl}/FrameworkDocuments/${document.docUrl}`;

      JSZipUtils.getBinaryContent(filePath, (err, data) => {
        if (err) {
          throw err;
        }

        zip.file(fileName, data, { binary: true });
        count++;
        if (count === documents.length) {
          zip.generateAsync({ type: "blob" }).then((content) => {
            saveAs(content, zipFolderName);
            props.setLoader(false);
          });
        }
      });
    });
  };

  const downloadPdf = (pdfLink) => {
    window.open(pdfLink);
  };

  const formatDocumentSize = (sizeInBytes) => {
    const megaBytes = sizeInBytes / 1e6;
    const kiloBytes = sizeInBytes / 1e3;

    if (megaBytes >= 1) {
      return `${megaBytes.toFixed(1)} mb`;
    } else {
      return `${Math.trunc(kiloBytes)} kb`;
    }
  };

  const transformDocumentsData = () => {
    const transformedDocuments = props.docsData.map((doc) => {
      return {
        ...doc,
        isSelected: false,
      };
    });
    //console.log("tranformed doc ----", transformedDocuments);
    setTransformedDocuments(transformedDocuments);
  };

  useEffect(() => {
    if (props.docsData) {
      transformDocumentsData();
    }
  }, [props.docsData]);

  const [frameworkIdToDelete, setFrameworkIdToDelete] = useState(null);
  const deleteDocument = (frameworkId) => {
    setFrameworkIdToDelete(frameworkId);
    setAreYouSure(true);
  };

  const responseFromAreYouSure = async (bool) => {
    if (bool) {
      props.setLoader(true);
      window.scrollTo(0, 0);

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
     
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "delete",
          url: `${endPoints.baseUrl}/framework/deleteFrameworkDocument`,
          params: {
            id: frameworkIdToDelete,
          },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((res) => {
          if (res.data.code == 403) {
            props.sessionTimeOutCheck(true);
            props.setLoader(false)
          }
          //console.log(res);

          props.getAllPdfs();
          setAreYouSure(false);
          props.setLoader(false);
        });
      } else {
        props.sessionTimeOutCheck(true);
        props.setLoader(false)
      }
    } else {
      setAreYouSure(false);
    }
  };

  return (
    <div className={`${styles.automationFactoryContainer} container`}>
      {areYouSure ? (
        <AreyousureModal
          title="Framework"
          message={"Are you sure?"}
          fail={true}
          setSuccessModal={responseFromAreYouSure}
          areYouSure={true}
        />
      ) : null}
      <div className={styles.factoryHead}>
        <div className={styles.left}>
          <p>{_get(props, "data", "")}</p>
        </div>
        <div className={styles.right}>
          <span
            className={`${styles.downloadSelected}`}
            disabled={isButtonDisabled}
            onClick={downloadSelectedDocuments}
          >
            {_get(props, "download[0]", "")}
          </span>
          <span className={styles.downloadAll} onClick={downloadAllDocuments}>
            <Icons
              name="downloadWhite"
              className={styles.downloadWhite}
            ></Icons>
            {_get(props, "download[1]", "")}
          </span>
        </div>
      </div>

      <div className={styles.assetsWrapper}>
        <div className={styles.selectAllCheck}>
          <label className={styles.list_Checkbox_container}>
            <span className={styles.lableHead}>Select all</span>
            <input type="checkbox" onChange={(e) => selectAllDocuments(e)} />
            <span className={styles.list_checkmark}></span>
          </label>
        </div>

        {transformedDocuments.map((item, index) => (
          <div
            className={
              item.isSelected
                ? `${styles.pdfCard} ${styles.active}`
                : styles.pdfCard
            }
            key={index}
          >
            <div className={styles.head}>
              <div
                className={`  ${
                  item.isSelected ? styles.iconview : styles.iconWrap
                }`}
              >
                <span className={styles.check}>
                  <label className={styles.list_Checkbox_container}>
                    <input
                      type="checkbox"
                      onChange={(e) => selectDocumentsHandler(e, index)}
                      checked={item.isSelected ? true : false}
                    />
                    <span className={styles.list_checkmark}></span>
                  </label>
                </span>
                <Icons name={item.docType} className={styles.icon} />
              </div>

              <div class={styles.pdfTitle}>
                <div>
                  <p>
                    {item.docName.length > 15
                      ? `${item.docName.slice(0, 16)}...`
                      : item.docName}
                  </p>
                </div>
                <small>{formatDocumentSize(item.docSize)}</small>
              </div>
              
              {
                props.auth.userType == "admin" ? 
              
              
              <div
                className={styles.deleteIcon}
                onClick={() => {
                  deleteDocument(item.frameworkId);
                }}
              >
                <Icons name="deleteicon" className={styles.icon} />
              </div>
              : null }

              <div
                onClick={() => {
                  downloadPdf(`${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`);
                }}
                className={styles.mobileDownloadIcon}
              >
                <Icons name="downloadBlue"></Icons>
              </div>
              <div
                onClick={() => {
                  downloadPdf(`${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`);
                }}
              ></div>
            </div>
            <div
              className={styles.body}
              onClick={() => {
                downloadPdf(`${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`);
              }}
            >
              <div className={styles.downloadOverlay}>
                <div className={styles.downloadBtn}>
                  <Icons name="downloadWhite" className={styles.download} />
                  <span>Download</span>
                </div>
              </div>
              <div className={styles.objWrapper}>
                <iframe
                  style={{ width: "100%" }}
                  src={
                    item.docType == "xlsx" ||
                    item.docType == "doc" ||
                    item.docType == "docx"
                      ? `https://docs.google.com/viewerng/viewer?embedded=true&url=${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`
                      : item.docType == "ppt" ||
                        item.docType == "pptx" ||
                        item.docType == "msg"
                      ? `https://view.officeapps.live.com/op/embed.aspx?src=${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`
                      : `${endpoints.fetchBlobUrl}/FrameworkDocuments/${item.docUrl}`
                  }
                  type={`application/${item.docType}`}
                  width="220"
                  height="100"
                ></iframe>
                {/* <object
                    data={`https://newbotstore.blob.core.windows.net/botstorevideo/${item.docUrl}&embedded=true`}
                    type="application/pdf"
                    width="220px"
                    height="100px"
                    border="none"
                  /> */}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        className={styles.mobileDownloadAll}
        onClick={downloadSelectedDocuments}
      >
        <span className={styles.btn}>{_get(props, "download[0]", "")}</span>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
